"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.boolToMode = boolToMode;
exports.modeToBool = modeToBool;
var _enums = require("../../enums");
var AUTO = _enums.AutoscaleMode.AUTO,
  ADJUSTABLE = _enums.AutoscaleMode.ADJUSTABLE;
function boolToMode(nextBool) {
  return nextBool ? AUTO : ADJUSTABLE;
}
function modeToBool(nextMode) {
  return nextMode === AUTO;
}